/* Painter Pro — minimal theme JS. No dependencies. */
(function () {
  'use strict';

  /* Mobile drawer */
  var drawer = document.getElementById('MenuDrawer');
  var openBtn = document.querySelector('[data-drawer-open]');
  var lastFocus = null;

  function setDrawer(open) {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
    if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      lastFocus = document.activeElement;
      var close = drawer.querySelector('.drawer__close');
      if (close) close.focus();
    } else if (lastFocus) {
      lastFocus.focus();
    }
  }

  if (openBtn) openBtn.addEventListener('click', function () { setDrawer(true); });
  document.querySelectorAll('[data-drawer-close]').forEach(function (el) {
    el.addEventListener('click', function () { setDrawer(false); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setDrawer(false);
  });

  /* Smooth scroll to the estimate form from any #quote link */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href="#quote"], a[href^="#quote"]');
    if (!link) return;
    var target = document.getElementById('quote');
    if (!target) return;
    e.preventDefault();
    setDrawer(false);
    var offset = 80;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: top, behavior: 'smooth' });
    var firstInput = target.querySelector('input, select, textarea');
    if (firstInput) setTimeout(function () { firstInput.focus({ preventScroll: true }); }, 500);
  });

  /* Scroll reveal */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Keep only one FAQ open at a time within a group */
  document.querySelectorAll('[data-faq-group]').forEach(function (group) {
    group.querySelectorAll('details').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        group.querySelectorAll('details').forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  });

  /* If a contact form posted successfully, scroll the confirmation into view */
  var posted = document.querySelector('[data-form-status]');
  if (posted) {
    posted.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
  }
})();
